import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=de709212"
import script from "./login2.vue?vue&type=script&lang=js"
export * from "./login2.vue?vue&type=script&lang=js"
import style0 from "./login2.vue?vue&type=style&index=0&id=de709212&prod&lang=scss"
import style1 from "./login2.vue?vue&type=style&index=1&id=de709212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports